module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-960-936661a9261799d709e8bc39dc145abd.webp";